import React from "react";
import CustomAccordion from "../../utils/Accordion/CustomAccordion";
import VerticalTabs from "../../utils/Tab/VerticalTabs.js"
import { Box } from "@mui/material";

const Faq = () => {
  const sections = [
    { label: "section 1", content: "content 1" },
    { label: "section 2", content: "content 2" },
    { label: "section 3", content: "content 3" },
  ];
  const tab = [
    {
      label: "Group 1",
      content: (
        <div className="container">
          <CustomAccordion sections={sections} />
        </div>
      ),
    },
    {
      label: "Group 2",
      content: (
        <div className="container">
          <CustomAccordion sections={sections} />
        </div>
      ),
    },
    {
      label: "Group 3",
      content: (
        <div className="container">
          <CustomAccordion sections={sections} />
        </div>
      ),
    },
  ];

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flexGrow: 1, p: 3, m: 15 }}>
          <VerticalTabs tabs={tab} />
        </Box>
      </Box>
    </>
  );
};

export default Faq;
